export default "/images/vendor/flag-icons/flags/4x3/ug.svg?420c4555daccc49421090160061f3860";